(<template>
    <div :class="styleClass">
      <h1 id="title-new-partner-company" v-if="!loadedForm" v-translate>Add a new partner company</h1>
      <h1 id="title-edit-partner-company" v-else v-translate>Edit partner company</h1>
      <el-form :model="partnerCompanyForm"
               :rules="rules"
               ref="partnerCompanyForm"
               label-position="left"
               label-width="12em">
        <el-form-item prop="name">
          <span slot="label" v-translate>Name</span>
          <el-input id="input-name"
                    :placeholder="namePlaceholder.hu"
                    v-model="partnerCompanyForm.name.hu"
                    @focus="showName=true"></el-input>
          <el-collapse-transition>
            <div v-show="showName">
              <el-input id="input-name-en"
                        class="input-style"
                        :placeholder="namePlaceholder.en"
                        v-model="partnerCompanyForm.name.en"></el-input><br />
              <el-input id="input-name-ro"
                        class="input-style"
                        :placeholder="namePlaceholder.ro"
                        v-model="partnerCompanyForm.name.ro"></el-input>
            </div>
          </el-collapse-transition>
        </el-form-item>
        <el-form-item prop="description">
          <span slot="label" v-translate>Description</span>
          <el-input id="input-name"
                    type="textarea"
                    :placeholder="descriptionPlaceholder.hu"
                    v-model="partnerCompanyForm.description.hu"
                    @focus="showDescription=true"></el-input>
          <el-collapse-transition>
            <div v-show="showDescription">
              <el-input id="input-name-en"
                        type="textarea"
                        class="input-style"
                        :placeholder="descriptionPlaceholder.en"
                        v-model="partnerCompanyForm.description.en"></el-input><br />
              <el-input id="input-name-ro"
                        type="textarea"
                        class="input-style"
                        :placeholder="descriptionPlaceholder.ro"
                        v-model="partnerCompanyForm.description.ro"></el-input>
            </div>
          </el-collapse-transition>
        </el-form-item>
        <el-form-item prop="category">
          <span slot="label" v-translate>Category</span>
          <el-select v-model="selectedValue" @change="handleSelectionChange" :placeholder="categoryPlaceholder" class="dropdown-style">
            <el-option
              v-for="(value, key) in categories"
                :key="key"
                :label="value"
                :value="key"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="address">
          <span slot="label" v-translate>Address</span>
          <el-input id="input-name"
                    placeholder=""
                    v-model="partnerCompanyForm.address"
                    ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <span slot="label" v-translate>Phone number</span>
          <el-input id="input-name"
                    placeholder=""
                    v-model="partnerCompanyForm.phone"
                    ></el-input>
        </el-form-item>
        <el-form-item prop="website">
          <span slot="label" v-translate>Website</span>
          <el-input id="input-name"
                    placeholder=""
                    v-model="partnerCompanyForm.website"
                    ></el-input>
        </el-form-item>
        <el-form-item prop="position">
          <span slot="label" v-translate>Coordinates</span>
          <map-view id="map-view"
                    :position="partnerCompanyForm.position"
                    :is-editable="true"
                    @set-position="setPosition"></map-view>
        </el-form-item>
        <el-form-item prop="images">
          <span slot="label" v-translate>Images</span>
          <image-uploader :images="partnerCompanyForm.images"
                          @image-added="addImage"
                          @image-removed="removeImage"></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-button v-if="loadedForm" @click="cancel">
            <span v-if="loadedForm" v-translate>Cancel</span>
          </el-button>
          <el-button id="button-upload" type="primary" @click="submitForm('partnerCompanyForm')">
            <span v-if="loadedForm" v-translate>Update</span>
            <span v-else v-translate>Upload</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>)
  
  (<script>
  import axios from 'axios'
  import ImageUploader from './Image-Uploader.vue'
  import MapView from './Map-View.vue'
  
  export default {
    name: 'partner-company-upload-form',
    components: {
      'image-uploader': ImageUploader,
      'map-view': MapView
    },
    props: ['loaded-form'],
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.$session.exists()) {
          next()
        } else {
          next('/signin')
        }
      })
    },
    data () {
      var styleClass = this.loadedForm ? 'update-form' : 'form'
      var partnerCompanyForm = this.loadedForm || {
        name: {
          hu: null,
          en: null,
          ro: null
        },
        description: {
          hu: null,
          en: null,
          ro: null
        },
        category: null,
        address: null,
        phone: null,
        website: null,
        position: { lat: null, lng: null },
        images: []
      }
      partnerCompanyForm.removedImages = []
      partnerCompanyForm.newImages = []
      return {
        selectedValue: '',
        namePlaceholder: {
          hu: this.$gettext('Name in Hungarian'),
          en: this.$gettext('Name in English'),
          ro: this.$gettext('Name in Romanian')
        },
        descriptionPlaceholder: {
          hu: this.$gettext('Description in Hungarian'),
          en: this.$gettext('Description in English'),
          ro: this.$gettext('Description in Romanian')
        },
        categoryPlaceholder: this.$gettext('Select a category'),
        styleClass,
        showName: false,
        showDescription: false,
        showCategory: false,
        partnerCompanyForm,
        categories: null,
        rules: {
          name: {
            type: 'object',
            required: true,
            fields: {
              hu: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
              en: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
              ro: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')}
            }
          },
          description: {
            type: 'object',
            required: false,
            fields: {
              hu: [
                {type: 'string', required: false, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ],
              en: [
                {type: 'string', required: false, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ],
              ro: [
                {type: 'string', required: false, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ]
            }
          },
          category: {
            required: true,
            message: this.$gettext('Please choose a category')
          },
          images: {
            type: 'array',
            required: true,
            message: this.$gettext('Please add images')
          },
          address: {
            type: 'string',
            required: true,
            defaultField: {type: 'string', message: this.$gettext('Address is not valid')},
            message: this.$gettext('Please add address')
          },
          phone: {
            type: 'string',
            required: false,
            defaultField: {type: 'string', message: this.$gettext('Phone number is not valid')}
          },
          website: {
            type: 'url',
            required: false,
            defaultField: {type: 'url', message: this.$gettext('Url is not valid')},
            message: this.$gettext('Invalid website URL')
          },
          position: {
            type: 'object',
            required: true,
            message: this.$gettext('Please set the coordinates'),
            trigger: 'change',
            fields: {
              lat: {type: 'float', required: true, message: this.$gettext('Please set the coordinates')},
              lng: {type: 'float', required: true, message: this.$gettext('Please set the coordinates')}
            }
          }
        }
      }
    },
    created () {
      this.getCategories()
      if (this.loadedForm) {
        this.selectedValue = this.partnerCompanyForm.category[this.$language.current]
      }
    },
    methods: {
      substract (a, b) {
        return a.filter(element => b.indexOf(element) < 0)
      },
      handleSelectionChange (key) {
        this.partnerCompanyForm.category = key
      },
      handleSelectionClick () {

      },
      setPosition (position) {
        this.partnerCompanyForm.position = position
      },
      getCategories () {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/companies/categories?lang=${this.$language.current}`
        })
        .then(response => {
          this.categories = response.data
        })
      },
      uploadForm () {
        axios({
          method: 'post',
          url: `${process.env.SERVER_URL}/companies`,
          headers: {'Content-Type': 'application/json'},
          data: this.partnerCompanyForm,
          withCredentials: true
        })
        .then(response => {
          this.$message({
            type: 'success',
            message: response.data || response.statusText
          })
          this.$router.push('/companies/list')
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      updateForm () {
        let categoryKey = ''
        for (const [key, value] of Object.entries(this.categories)) {
          if (value === this.selectedValue) {
            categoryKey = key
          }
        }
        if (categoryKey === '') {
          categoryKey = this.selectedValue
        }
        this.partnerCompanyForm.category = categoryKey
        axios({
          method: 'put',
          url: `${process.env.SERVER_URL}/companies/${this.partnerCompanyForm.id}`,
          headers: {'Content-Type': 'application/json'},
          data: this.partnerCompanyForm,
          withCredentials: true
        })
        .then(response => {
          this.$message({
            type: 'success',
            message: response.data || response.statusText
          })
          this.$emit('close-edit')
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      cancel () {
        this.$confirm(this.$gettext('Are you sure to close?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          this.$emit('close-edit')
        }).catch(() => {})
      },
      addRow () {
        this.partnerCompanyForm.urls.push('')
      },
      deleteRow (index, rows) {
        rows.splice(index, 1)
      },
      saveRow (index, rows, row) {
        rows.splice(index, 1, row)
      },
      addImage (imageFileName) {
        this.partnerCompanyForm.newImages.push(imageFileName)
      },
      removeImage (imageFileName) {
        this.partnerCompanyForm.removedImages.push(imageFileName)
        this.partnerCompanyForm.images.splice(this.partnerCompanyForm.images.indexOf(imageFileName), 1)
        this.partnerCompanyForm.newImages.splice(this.partnerCompanyForm.newImages.indexOf(imageFileName), 1)
      },
      submitForm (formName) {
        if (this.partnerCompanyForm.images.length === 0) {
          this.partnerCompanyForm.images = [].concat(this.partnerCompanyForm.newImages)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.loadedForm) {
              this.updateForm()
            } else {
              this.uploadForm()
            }
          }
        })
      }
    }
  }
  </script>)
  
  (<style>
  .input-style {
    margin-top: 1%;
  }
  .update-form {
    padding: 5%;
  }
  .url-component {
    max-height: 250px;
    width: 100%;
  }
  .dropdown-style {
    margin-top: 1%;
    width: 100%;
  }
  </style>)
  


// WEBPACK FOOTER //
// src/components/Partner-Companies-Upload-Form.vue